import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api-base';
import { ICoverageReport } from './coverageReport.interface';

export namespace CoverageReportAction {
  const actionCreator = actionCreatorFactory('CoverageReport');

  // Create needs the owning server; rename (update) keeps the report's server unchanged.
  interface ICoverageReportCreateParams {
    payload: { name: string; serverId: ICoverageReport['serverId'] };
    resolve: (reportId?: ICoverageReport['reportId']) => void;
  }

  interface ICoverageReportUpdateParams {
    payload: { reportId: ICoverageReport['reportId']; name: string };
    resolve: (reportId?: ICoverageReport['reportId']) => void;
  }

  interface ICoverageReportId {
    reportId: ICoverageReport['reportId'];
  }

  interface ICoverageReportCreated {
    reportId: ICoverageReport['reportId'];
  }

  export const create = actionCreator.async<ICoverageReportCreateParams, ICoverageReportCreated, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ICoverageReportUpdateParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<ICoverageReportId, void, IApiErrorParams>('REMOVE');

  export const loadList = actionCreator.async<void, ICoverageReport[], IApiErrorParams>('LOAD_LIST');

  export const destroy = actionCreator('DESTROY');
}
